/* eslint-disable import/no-default-export */
import ProfileCover from './ProfileCover';

export { ProfileCover };
export default ProfileCover;
